import Vue from 'vue'
import Vuex from 'vuex'

import app from '@/store/app'
import tasks from '@/store/tasks/tasks'
import modals from '@/store/modals/modals'
import location from '@/store/location/location'
import lead from '@/store/lead/lead'
import rooms from '@/store/rooms/rooms'
import groups from '@/store/groups/groups'
import inventory from '@/store/inventory/inventory'
import services from '@/store/services/services'
import overlays from '@/store/overlays/overlays'
import signature from '@/store/signature/signature'
import comments from '@/store/comments/comments'
import photos from '@/store/photos/photos'
import loader from '@/store/loader/loader'
import flashMessage from '@/store/flash-message/flash-message'
import notifications from '@/store/notifications/notifications'
import users from '@/store/users/users'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    tasks,
    modals,
    location,
    lead,
    rooms,
    groups,
    inventory,
    services,
    overlays,
    signature,
    comments,
    photos,
    loader,
    notifications,
    users,
    flashMessage,
  },
})
